(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window)) return;

  /* Shopify JSON-template sections render as
     #shopify-section-template--<template id>__<section key> (the numeric template id
     varies per store/session), so match by section-key suffix rather than a literal id. */
  var fadeTargets = document.querySelectorAll(
    '[id$="__product_showcase_1"], ' +
      '[id$="__founder_teaser_1"]'
  );

  if (fadeTargets.length) {
    fadeTargets.forEach(function (el) {
      el.classList.add('scroll-fade-up');
    });

    var fadeObserver = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('scroll-in-view');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    fadeTargets.forEach(function (el) {
      fadeObserver.observe(el);
    });
  }

  /* "The Élanora Difference" gallery: same fade + gentle rise, one-time-trigger
     pattern as "Finishing touch" below, own class since duration/easing differ from
     .scroll-fade-up. */
  var differenceGallery = document.querySelector('[id$="__difference_gallery_1"]');
  if (differenceGallery) {
    differenceGallery.classList.add('difference-gallery-fade');

    var differenceGalleryObserver = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('scroll-in-view');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    differenceGalleryObserver.observe(differenceGallery);
  }

  /* "Finishing touch" carousel section: fade + gentle rise, same one-time-trigger
     behavior as the fadeTargets group above, but its own class since the duration
     (1.3s) and easing curve differ from .scroll-fade-up. */
  var finishingTouch = document.querySelector('[id$="__finishing_touch_1"]');
  if (finishingTouch) {
    finishingTouch.classList.add('finishing-touch-fade');

    var finishingTouchObserver = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('scroll-in-view');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    finishingTouchObserver.observe(finishingTouch);
  }

  /* NOTE: the "Consistency Is the Formula" two-image slide-in effect was removed.
     That banner (image_banner_RzTNwK) is now a single image plus a separate portrait
     mobile image — and that second .banner__media was re-triggering this ≥2-media
     slide, making the mobile hero slide in on scroll. The banner should sit still. */
})();
